import * as Types from '../../../graphql-types'

import { gql } from '@apollo/client'
export type Content_ProviderCommonFragmentFragment = {
  __typename?: 'ContentProvider'
  contentId?: string | null
}

export const Content_ProviderCommonFragmentFragmentDoc = gql`
  fragment Content_ProviderCommonFragment on ContentProvider {
    contentId
  }
`
